import React, { useEffect, useState } from "react";
import "./css/Syllabus.css";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getClassesList,
  getGroupsList,
  getTopicsList,
} from "./redux/studentThunk";
import { setState } from "./redux/studentSlice";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";

const Syllabus = () => {
  const dispatch = useDispatch();
  const isPageReload = () => {
    const [entry] = performance.getEntriesByType("navigation");
    return entry?.type === "reload";
  };
  const [quizType, setQuizType] = useState(() => {
    if (isPageReload()) return localStorage.getItem("quizType") || "";
    localStorage.removeItem("quizType");
    localStorage.removeItem("selected_class_id");
    localStorage.removeItem("selected_group_id");
    return "";
  });

  const {
    category,
    classes,
    class_id,
    subject_id,
    topicInfo,
    contentInPopUp,
    showPopUp,
    group_id,
    groups,
  } = useSelector((state) => state.student);
  useEffect(() => {
    if (!isPageReload()) {
      dispatch(setState({ key: "class_id", value: null }));
      dispatch(setState({ key: "group_id", value: null }));
      dispatch(setState({ key: "subject_id", value: null }));
      dispatch(setState({ key: "category", value: null }));
      dispatch(setState({ key: "contentInPopUp", value: null }));
      dispatch(setState({ key: "showPopUp", value: false }));
    }
  }, []);

  useEffect(() => {
    if (classes?.length > 0 && !class_id) {
      const savedId = isPageReload()
        ? localStorage.getItem("selected_class_id")
        : null;
      const match =
        savedId && classes.find((c) => String(c.class_id) === savedId);
      dispatch(
        setState({
          key: "class_id",
          value: match ? match.class_id : classes[0].class_id,
        }),
      );
    }
    if (groups?.length > 0 && !group_id) {
      const savedId = isPageReload()
        ? localStorage.getItem("selected_group_id")
        : null;
      const match =
        savedId && groups.find((g) => String(g.group_id) === savedId);
      dispatch(
        setState({
          key: "group_id",
          value: match ? match.group_id : groups[0].group_id,
        }),
      );
    }
  }, [classes, groups]);
  useEffect(() => {
    if (class_id) localStorage.setItem("selected_class_id", class_id);
  }, [class_id]);

  useEffect(() => {
    if (group_id) localStorage.setItem("selected_group_id", group_id);
  }, [group_id]);

  useEffect(() => {
    dispatch(getClassesList());
    dispatch(getTopicsList());
    dispatch(getGroupsList());
  }, [dispatch]);

  // useEffect(() => {
  //   if (classes?.length > 0 && !class_id) {
  //     dispatch(setState({ key: "class_id", value: classes[0].class_id }));
  //   }
  //   if (groups?.length > 0 && !group_id) {
  //     dispatch(setState({ key: "group_id", value: groups[0].group_id }));
  //   }
  // }, [classes, groups]);

  // Drop duplicate class rows like "Class 9" / "class 09" (same number, different label)
  const classKey = (name = "") =>
    name.replace(/\D/g, "").replace(/^0+/, "") || name.trim().toLowerCase();

  const uniqueClasses = classes?.filter(
    (cls, i, arr) =>
      arr.findIndex(
        (c) => classKey(c.class_name) === classKey(cls.class_name),
      ) === i,
  );

  // CATEGORY 1 → CLASS-WISE DATA
  const filteredTopicsList = topicInfo?.filter(
    (item) => item.category_id === 1,
  )[0]?.topics;

  const filteredTopics = filteredTopicsList?.filter(
    (item) => item.class_id === class_id,
  );

  const subjectsGrouped = filteredTopics?.reduce((acc, item) => {
    if (!acc[item.subject_name]) {
      acc[item.subject_name] = [];
    }
    acc[item.subject_name].push(item);
    return acc;
  }, {});

  // CATEGORY 2 → GROUP-WISE THEMES
  const filteredThematicList = topicInfo?.filter(
    (item) => item.category_id === 2,
  )[0]?.topics;

  const filteredThemesInfo = filteredThematicList?.filter(
    (item) => item.group_id === group_id,
  );

  const subjectsGroupedNew = filteredThemesInfo?.reduce((acc, item) => {
    if (!acc[item.theme_name]) {
      acc[item.theme_name] = [];
    }
    acc[item.theme_name].push(item);
    return acc;
  }, {});

  const resetForm = () => {
    dispatch(setState({ key: "showPopUp", value: false }));
  };

  const handlePopUp = (category, subject_name, data) => {
    dispatch(setState({ key: "subject_id", value: subject_name }));
    dispatch(setState({ key: "contentInPopUp", value: data }));
    dispatch(setState({ key: "showPopUp", value: true }));
    dispatch(setState({ key: "category", value: category }));
  };

  // Modern card colors
  const cardColors = [
    {
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      accent: "#667eea",
    },
    {
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      accent: "#f5576c",
    },
    {
      gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      accent: "#4facfe",
    },
    {
      gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
      accent: "#43e97b",
    },
    {
      gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
      accent: "#fa709a",
    },
    {
      gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
      accent: "#a8edea",
    },
    {
      gradient: "linear-gradient(135deg, #5ee7df 0%, #b490ca 100%)",
      accent: "#5ee7df",
    },
    {
      gradient: "linear-gradient(135deg, #d299c2 0%, #fef9d7 100%)",
      accent: "#d299c2",
    },
  ];

  // Styles for the component
  const styles = {
    noDataMessage: {
      textAlign: "center",
      color: "#e74c3c",
      padding: "20px",
      fontSize: "16px",
      width: "100%",
    },
    popupTitle: {
      textAlign: "center",
      fontWeight: "bold",
      fontSize: "20px",
      width: "100%",
      display: "block",
    },
    popupContent: {
      overflowY: "auto",
      paddingRight: "10px",
    },
    topicItem: {
      marginBottom: "12px",
    },
    topicName: {
      fontWeight: "bold",
      marginBottom: "4px",
    },
    topicDescription: {
      marginTop: "4px",
      paddingLeft: "0",
    },
    // Modern card styles
    modernCard: {
      background: "#ffffff",
      borderRadius: "16px",
      boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)",
      overflow: "hidden",
      transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
      height: "auto",
      minHeight: "unset",
      border: "1px solid rgba(0, 0, 0, 0.05)",
    },
    cardHeader: {
      padding: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
    },
    subjectNameModern: {
      fontSize: "18px",
      fontWeight: "700",
      color: "#1a1a2e",
      margin: 0,
      letterSpacing: "-0.3px",
    },
    viewButton: {
      background: "#28a745",
      color: "#ffffff",
      border: "none",
      padding: "8px 20px",
      borderRadius: "20px",
      fontSize: "13px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "all 0.3s ease",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    cardBody: {
      padding: "16px 20px 20px",
    },
    topicsLabel: {
      fontSize: "12px",
      fontWeight: "600",
      color: "#6b7280",
      textTransform: "uppercase",
      letterSpacing: "0.8px",
      marginBottom: "12px",
    },
    topicsList: {
      listStyle: "none",
      padding: 0,
      margin: 0,
    },
    topicItemStyle: {
      display: "flex",
      alignItems: "center",
      padding: "8px 0",
      borderBottom: "1px solid rgba(0, 0, 0, 0.04)",
    },
    topicItemLast: {
      display: "flex",
      alignItems: "center",
      padding: "8px 0",
      borderBottom: "none",
    },
    topicDot: {
      width: "6px",
      height: "6px",
      borderRadius: "50%",
      marginRight: "12px",
      flexShrink: 0,
    },
    topicText: {
      fontSize: "14px",
      fontWeight: "500",
      color: "#374151",
    },
  };

  return (
    <div className="syllabus-page">
      <style>{`
        .modern-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12) !important;
        }
        
        .view-btn:hover {
          transform: scale(1.05);
          background: #218838 !important;
        }
        
        .topic-item-hover:hover {
          background: rgba(102, 126, 234, 0.04);
          margin: 0 -20px;
          padding-left: 20px !important;
          padding-right: 20px !important;
        }

.quiz-type-btn {
  flex: 1;
  min-width: 180px;
  max-width: 260px;
  padding: 14px 24px;
  border: 2px solid transparent;
  border-radius: 10px;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  text-align: center;
  opacity: 0.6;              /* inactive = dimmed */
  position: relative;
}

/* Inactive state — muted look */
.quiz-type-btn.subjective {
  background: #e9f7ec;
  color: #28a745;
  border-color: #28a745;
}

.quiz-type-btn.thematic {
  background: #eef0fd;
  color: #667eea;
  border-color: #667eea;
}

/* Active state — filled, bold, lifted */
.quiz-type-btn.subjective.active {
  background: #28a745;
  color: #fff;
  opacity: 1;
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(40, 167, 69, 0.35);
}

.quiz-type-btn.thematic.active {
  background: #667eea;
  color: #fff;
  opacity: 1;
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.35);
}

/* Optional: checkmark icon on active */
.quiz-type-btn.active::before {
  content: "✓ ";
  font-weight: 700;
}

.quiz-type-btn:hover {
  opacity: 1;
  transform: translateY(-2px);
}
        @media (max-width: 768px) {
          .modern-card {
            border-radius: 12px !important;
          }
          .card-header-modern {
            padding: 16px !important;
          }
          .card-body-modern {
            padding: 12px 16px 16px !important;
          }  .quiz-type-section {
      flex-direction: column;
      gap: 20%;
    }
    .quiz-type-btn {
      max-width: 100%;
    }

        }
      `}</style>

      <section className="quiz-type-section">
        <button
          className={`quiz-type-btn subjective ${
            quizType === "subjective" ? "active" : ""
          }`}
          onClick={() => {
            setQuizType("subjective");
            localStorage.setItem("quizType", "subjective");
          }}
        >
          Subjective Quiz Syllabus
        </button>
        &nbsp;
        <button
          className={`quiz-type-btn thematic ${
            quizType === "thematic" ? "active" : ""
          }`}
          onClick={() => {
            setQuizType("thematic");

            localStorage.setItem("quizType", "thematic");
          }}
        >
          Thematic Quiz Syllabus
        </button>
      </section>
      {quizType === "subjective" ? (
        <>
          {/* Header Section */}
          <section className="syllabus-header">
            <div className="syllabus-container">
              <h1 className="syllabus-title">Quiz Syllabus</h1>
              <p className="syllabus-subtitle">
                Comprehensive syllabus for all quiz categories and classes
              </p>
            </div>
          </section>

          {/* Class Tabs */}
          <section className="syllabus-tabs-section">
            <div className="syllabus-container">
              <div className="syllabus-tabs">
                {uniqueClasses?.length > 0 &&
                  uniqueClasses.map((cls) => (
                    <button
                      key={cls.class_id}
                      className={`syllabus-tab ${
                        class_id === cls.class_id ? "active" : ""
                      }`}
                      onClick={() =>
                        dispatch(
                          setState({ key: "class_id", value: cls.class_id }),
                        )
                      }
                    >
                      <span className="tab-title">{cls.class_name}</span>
                    </button>
                  ))}
              </div>
            </div>
          </section>

          {/* CATEGORY 1 CONTENT */}
          <section className="syllabus-content" style={{ minHeight: "auto" }}>
            <div className="syllabus-container">
              <div className="subject-grid">
                {subjectsGrouped &&
                  Object.keys(subjectsGrouped).map((subject, idx) => {
                    const colorSet = cardColors[idx % cardColors.length];
                    return (
                      <div
                        key={idx}
                        className="modern-card"
                        style={styles.modernCard}
                      >
                        <div
                          className="card-header-modern"
                          style={styles.cardHeader}
                        >
                          <h3 style={styles.subjectNameModern}>{subject}</h3>
                          <button
                            className="view-btn"
                            style={styles.viewButton}
                            onClick={() =>
                              handlePopUp(
                                "1",
                                subject,
                                subjectsGrouped[subject],
                              )
                            }
                          >
                            View Syllabus
                          </button>
                        </div>

                        <div
                          className="card-body-modern"
                          style={styles.cardBody}
                        >
                          <p style={styles.topicsLabel}>
                            Topics covered in this Subject
                          </p>

                          <ul style={styles.topicsList}>
                            {subjectsGrouped[subject].map((topic, topicIdx) => (
                              <li
                                key={topic.id}
                                className="topic-item-hover"
                                style={
                                  topicIdx ===
                                  subjectsGrouped[subject].length - 1
                                    ? styles.topicItemLast
                                    : styles.topicItemStyle
                                }
                              >
                                <span
                                  style={{
                                    ...styles.topicDot,
                                    background: "#28a745",
                                  }}
                                ></span>
                                <span style={styles.topicText}>
                                  {topic.topic}
                                </span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>

            {subjectsGrouped &&
              Object.keys(subjectsGrouped).length === 0 &&
              class_id && (
                <p style={styles.noDataMessage}>
                  No Syllabus found for the selected Class
                </p>
              )}
          </section>
        </>
      ) : quizType === "thematic" ? (
        <>
          {/* THEMATIC CONTENT (CATEGORY 2) */}
          <section className="thematic-section">
            <div className="syllabus-container">
              <div className="thematic-header">
                <h2 className="thematic-title">Thematic Quiz Topics</h2>
                <p className="thematic-subtitle">
                  Special campaign topics for all classes
                </p>
              </div>

              <section className="syllabus-tabs-section">
                <div className="syllabus-container">
                  <div className="syllabus-tabs">
                    {groups?.length > 0 &&
                      groups.map((cls) => (
                        <button
                          key={cls.group_id}
                          className={`syllabus-tab ${
                            group_id === cls.group_id ? "active" : ""
                          }`}
                          onClick={() =>
                            dispatch(
                              setState({
                                key: "group_id",
                                value: cls.group_id,
                              }),
                            )
                          }
                        >
                          <span className="tab-title">{cls.group_name}</span>
                        </button>
                      ))}
                  </div>
                </div>
              </section>

              <section
                className="syllabus-content"
                style={{ minHeight: "auto" }}
              >
                <div className="syllabus-container">
                  <div className="subject-grid">
                    {subjectsGroupedNew &&
                      Object.keys(subjectsGroupedNew).map((subject, idx) => {
                        const colorSet = cardColors[idx % cardColors.length];
                        return (
                          <div
                            key={idx}
                            className="modern-card"
                            style={styles.modernCard}
                          >
                            <div
                              className="card-header-modern"
                              style={styles.cardHeader}
                            >
                              <h3 style={styles.subjectNameModern}>
                                {subject}
                              </h3>
                              <button
                                className="view-btn"
                                style={styles.viewButton}
                                onClick={() =>
                                  handlePopUp(
                                    "2",
                                    subject,
                                    subjectsGroupedNew[subject],
                                  )
                                }
                              >
                                View Syllabus
                              </button>
                            </div>

                            <div
                              className="card-body-modern"
                              style={styles.cardBody}
                            >
                              <p style={styles.topicsLabel}>
                                Topics covered in this Theme
                              </p>

                              <ul style={styles.topicsList}>
                                {subjectsGroupedNew[subject].map(
                                  (topic, topicIdx) => (
                                    <li
                                      key={topic.id}
                                      className="topic-item-hover"
                                      style={
                                        topicIdx ===
                                        subjectsGroupedNew[subject].length - 1
                                          ? styles.topicItemLast
                                          : styles.topicItemStyle
                                      }
                                    >
                                      <span
                                        style={{
                                          ...styles.topicDot,
                                          background: "#28a745",
                                        }}
                                      ></span>
                                      <span style={styles.topicText}>
                                        {topic.topic}
                                      </span>
                                    </li>
                                  ),
                                )}
                              </ul>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>

                {subjectsGroupedNew &&
                  Object.keys(subjectsGroupedNew).length === 0 && (
                    <p style={styles.noDataMessage}>
                      No Syllabus found for the selected Group
                    </p>
                  )}
              </section>
            </div>
          </section>
        </>
      ) : null}
      {/* POPUP */}
      <Dialog
        open={showPopUp}
        onClose={resetForm}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: "16px",
            boxShadow: "0 25px 80px rgba(0, 0, 0, 0.15)",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          style={{
            borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
            paddingBottom: "16px",
          }}
        >
          <span style={styles.popupTitle}>
            Syllabus for{" "}
            {category === "1" ? (
              <>{classes.find((c) => c.class_id === class_id)?.class_name} – </>
            ) : category === "2" ? (
              <>{groups.find((c) => c.group_id === group_id)?.group_name} – </>
            ) : (
              ""
            )}
            {subject_id}
          </span>

          <i
            className="bi bi-x"
            onClick={resetForm}
            style={{
              position: "absolute",
              right: "16px",
              top: "16px",
              cursor: "pointer",
              fontSize: 28,
              color: "#6b7280",
              transition: "color 0.2s ease",
            }}
          ></i>
        </DialogTitle>

        <DialogContent style={styles.popupContent}>
          {category === "1" || category === "2" ? (
            <ul style={{ ...styles.topicsList, paddingTop: "16px" }}>
              {contentInPopUp?.map((topic, idx) => (
                <li
                  key={topic.id}
                  style={{
                    marginBottom: "16px",
                    paddingBottom: "16px",
                    borderBottom:
                      idx !== contentInPopUp.length - 1
                        ? "1px solid rgba(0, 0, 0, 0.06)"
                        : "none",
                  }}
                >
                  <strong
                    style={{
                      fontSize: "15px",
                      color: "#1a1a2e",
                      display: "block",
                      marginBottom: "6px",
                    }}
                  >
                    {topic.topic}
                  </strong>
                  <div
                    className="topic-description"
                    style={{
                      fontSize: "14px",
                      color: "#6b7280",
                      lineHeight: "1.6",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: topic.description,
                    }}
                  />
                </li>
              ))}
            </ul>
          ) : null}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Syllabus;
